import { Bandeira } from './bandeira.enum';

export class AutenticacaoAutomatica {
    bandeira: Bandeira;
    cpf: string;
    dataNascimento: string;
    identificacaoParceiro?: string;
    authTicket?: string;
}
